import { Nullable } from "common/types";
import { List, Map, Record, fromJS } from "immutable";

export const queryParamsFromJSON = (data: Partial<IQueryParamsData>): QueryParamsRecord => {
  const record: IQueryParamsRecord = { ...(data as any) };
  if (data.parameters) {
    record.parameters = fromJS(data.parameters) as any;
  }

  return new QueryParamsRecord(record);
};
export interface IQueryParamsData {
  page: number;
  per_page: number;
  filter: string;
  query: Nullable<string>;
  folder_id?: Nullable<number>;
  parameters: { [key: string]: Nullable<string | string[] | Date | number> };
}

export interface IQueryParamsRecord {
  page: number;
  per_page: number;
  filter: string;
  query: string;
  folder_id?: Nullable<number>;
  parameters: Map<string, string | List<string> | Date>;
}

const defaultQueryParams: IQueryParamsRecord = {
  page: 1,
  per_page: 25,
  filter: "",
  query: "",
  folder_id: null,
  parameters: Map(),
};

export class QueryParamsRecord extends Record(defaultQueryParams) implements IQueryParamsRecord {}

export const emptyQueryParamsRecord = queryParamsFromJSON({} as any);
